export function buildMailTo(to: string, subject?: string, body?: string) {
  const mailToSubject = subject ? `subject=${encodeURIComponent(subject)}` : "";
  const mailToBody = body ? `body=${encodeURIComponent(body)}` : "";

  const hasTwoParams = mailToSubject && mailToBody;
  const params = mailToSubject + `${hasTwoParams ? "&" : ""}` + mailToBody;

  return `mailto:${to}${params ? `?${params}` : ""}`;
}
